import { authFetch } from "../utils/authFetch";
import { format } from "date-fns"; // Necesitamos esto para formatear las fechas
import { API_BASE_URL } from "../config";

const getIdSucursal = () => {
  return localStorage.getItem("idsucursal");
};

// Modificamos la función para que acepte un objeto con fechas
export const fetchTickets = async ({ from, to }) => {
  try {
    const idSucu = getIdSucursal();

    // Validamos y formateamos las fechas
    if (!from || !to) {
      throw new Error("Las fechas de inicio y fin son requeridas.");
    }
    const fechaInicioStr = format(from, "yyyy-MM-dd");
    const fechaFinStr = format(to, "yyyy-MM-dd");

    // Construimos la URL con el endpoint correcto y los parámetros
    const url = `${API_BASE_URL}/tickets/estado-pagados/1/sucursal/${idSucu}?fechaInicio=${fechaInicioStr}&fechaFin=${fechaFinStr}`;

    const response = await authFetch(url, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error("Error al obtener datos de estadísticas");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error en fetchTickets de estadisticaService:", error);
    throw error;
  }
};